(function (Drupal) {
  'use strict';

  Drupal.behaviors.actionbar = {
    attach: function (context, settings) {
      const actionBar = document.querySelector('.js-action-bar', context);
      const sideBar = document.querySelector('.js-action-sidebar', context);
      const html = document.querySelector('html', context);
      const body = document.querySelector('body', context);
      actionBar.addEventListener('click', function (e) {
        e.preventDefault();
        if (actionBar.classList.contains('is-active')) {
          actionBar.classList.remove('is-active');
          sideBar.classList.remove('is-active');
          html.classList.remove('is-scrolling');
          if (body.classList.contains('path-results')) {
            actionBar.innerHTML = 'Search again?';
          } else {
            actionBar.innerHTML = 'Show Summary & Help';
          }
        } else {
          actionBar.classList.add('is-active');
          sideBar.classList.add('is-active');
          html.classList.add('is-scrolling');
          if (body.classList.contains('path-results')) {
            actionBar.innerHTML = 'Hide Search';
          } else {
            actionBar.innerHTML = 'Hide Summary & Help';
          }
        }
      });
    }
  };
})(window.Drupal);
